import Cookies from 'js-cookie';
import { transferCookie } from '../tools/cookie';
import * as Logger from '../../common/tools/logger';
import {
  COOKIE_IDENTIFIER_IDCC
} from './config';
import { BRAND_DOMAIN } from '../../common/tools/util';

/**
 * Function to set the `idcc` cookie, based on the users permission
 * @param {string} status from updateTCString
 */
export const setIdccCookie = async(status: string): Promise<void> => {
  try {
    Cookies.remove(COOKIE_IDENTIFIER_IDCC);
    // eslint-disable-next-line no-empty
  } catch (ignore) {}

  const cookieValue = (status === 'CONSENT_REQUIRED') ? '0' : '1';
  try {
    Cookies.set(COOKIE_IDENTIFIER_IDCC, cookieValue, {
      domain: BRAND_DOMAIN,
      expires: 390,
      path: '/',
      secure: window.location.protocol === 'https:' ? true : false,
      sameSite: 'none'
    });
    await transferCookie(COOKIE_IDENTIFIER_IDCC, cookieValue, 390);
  } catch (error) {
    Logger.error(`Permission`, `setIdccCookie`, `Failed to set the 'idcc' cookie.`, error);
  }
}
